/* En-tête et bandeau de tout le site (refonte du site, cycle 2) : docs/superpowers/specs/2026-10-12-refonte-en-tete-design.md.
   1. compteur du panier (deux mécanismes, CLAUDE.md « Buy Buttons ») ; 2. bandeau ; 3. en-tête collé, caché en
   descendant, ligne compacte sur téléphone, verre de l'accueil ; 4. recherche ; 5. aperçu des univers ; 6. tiroir. */
(() => {
  const ordi = matchMedia('(min-width: 1024px)');
  const souris = matchMedia('(hover: hover) and (pointer: fine)');
  const reduit = matchMedia('(prefers-reduced-motion: reduce)');
  const etat = { recherche: false, apercu: false, plus: false };
  let el = {};

  /* 1. Compteur du panier : à l'identique de l'ancien en-tête (subscribe('cart-update') et MutationObserver sur
     <cart-drawer>) ; il tient aussi la pastille de la ligne compacte. */
  function majCompteur() {
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const lien = document.getElementById('cart-icon-bubble');
        if (lien) {
          let pastille = lien.querySelector('.cart-count');
          if (cart.item_count > 0) {
            if (!pastille) {
              pastille = document.createElement('span');
              pastille.className = 'cart-count';
              lien.appendChild(pastille);
            }
            pastille.textContent = cart.item_count;
            pastille.style.display = '';
          } else if (pastille) {
            pastille.style.display = 'none';
          }
        }
        document.querySelectorAll('[data-ent-panier-compact] .cart-count').forEach((p) => {
          p.textContent = cart.item_count;
          p.hidden = cart.item_count === 0;
        });
      })
      .catch(() => {});
  }

  function brancherCompteur() {
    if (typeof subscribe === 'function') subscribe('cart-update', majCompteur);
    const tiroirPanier = document.querySelector('cart-drawer');
    if (tiroirPanier) {
      let minuteur = null;
      new MutationObserver(() => {
        clearTimeout(minuteur);
        minuteur = setTimeout(majCompteur, 300);
      }).observe(tiroirPanier, { childList: true, subtree: true });
    }
  }

  /* 2. Bandeau : relais toutes les 4,5 s, bouton pause ; pas de relais automatique sous prefers-reduced-motion. */
  function initAnnonce() {
    const bandeau = document.querySelector('[data-ent-annonce]');
    if (!bandeau || bandeau.dataset.entPret) return;
    bandeau.dataset.entPret = '1';
    const msgs = [...bandeau.querySelectorAll('.ent-annonce__msg')];
    const bouton = bandeau.querySelector('.ent-annonce__pause');
    if (msgs.length < 2) {
      bouton.hidden = true;
      return;
    }
    let k = Math.max(0, msgs.findIndex((m) => m.classList.contains('is-on')));
    let minuteur = null;
    const suivant = () => {
      msgs[k].classList.remove('is-on');
      k = (k + 1) % msgs.length;
      msgs[k].classList.add('is-on');
    };
    const jouer = () => {
      clearInterval(minuteur);
      minuteur = setInterval(suivant, 4500);
      bandeau.classList.remove('is-pause');
      bouton.setAttribute('aria-label', bouton.dataset.entPause);
    };
    const pause = () => {
      clearInterval(minuteur);
      minuteur = null;
      bandeau.classList.add('is-pause');
      bouton.setAttribute('aria-label', bouton.dataset.entLecture);
    };
    bouton.addEventListener('click', () => (minuteur ? pause() : jouer()));
    if (reduit.matches) pause();
    else jouer();
  }

  /* 3. Défilement. Le seuil se mesure au repos : la position d'un élément collé suit le défilement et ne peut pas servir
     de seuil (défaut trouvé dans la maquette le 12/10). Haut naturel de l'en-tête = bas du bandeau, qui ne colle pas. */
  let seuil = 0;
  let haut = 0;
  let y0 = 0;
  let enAttente = false;

  function mesurer() {
    if (!el.section) return;
    const bandeau = document.querySelector('.section-ent-annonce');
    haut = bandeau ? bandeau.getBoundingClientRect().bottom + scrollY : 0;
    seuil = haut + el.section.offsetHeight + 80;
  }

  function verre() {
    if (!el.ent || !el.ent.classList.contains('ent--verre')) return;
    const premier = document.querySelector('#MainContent > .shopify-section');
    const plein = !premier || premier.getBoundingClientRect().bottom <= el.ent.offsetHeight;
    el.ent.classList.toggle('is-plein', plein);
  }

  function surDefilement() {
    enAttente = false;
    if (!el.section) return;
    const y = scrollY;
    if (etat.apercu) fermerApercu();
    if (etat.plus) fermerPlus(false);
    const ouvert = etat.recherche || (el.tiroir && el.tiroir.open);
    if (!ouvert) {
      if (y > seuil && y > y0 + 6) el.section.classList.add('is-cache');
      else if (y < y0 - 6 || y <= seuil) el.section.classList.remove('is-cache');
    }
    el.section.classList.toggle('is-defile', y > haut + 1);
    y0 = y;
    verre();
  }

  /* 4. Recherche : produits seuls, en vignettes (choix de l'exploitant du 12/10). */
  const cacheRecherche = new Map();
  let minuteurRecherche = null;
  let controleur = null;
  /* Échap rend le focus au champ : cette prise de focus-là ne rouvre pas le panneau. */
  let ignorerFocus = false;

  function majVoile() {
    if (el.voile) el.voile.hidden = !(etat.recherche || etat.apercu);
  }

  function afficherEssentiels(oui) {
    if (el.essentiels) el.essentiels.hidden = !oui;
  }

  function ouvrirRecherche() {
    if (etat.recherche || !el.panneau) return;
    fermerApercu();
    fermerPlus(false);
    etat.recherche = true;
    el.panneau.hidden = false;
    el.annuler.hidden = false;
    el.form.classList.add('is-ouvert');
    el.saisie.setAttribute('aria-expanded', 'true');
    majVoile();
  }

  function fermerRecherche(rendreFocus) {
    if (!etat.recherche) return;
    etat.recherche = false;
    el.panneau.hidden = true;
    el.annuler.hidden = true;
    el.form.classList.remove('is-ouvert');
    el.saisie.setAttribute('aria-expanded', 'false');
    majVoile();
    if (rendreFocus) {
      ignorerFocus = true;
      el.saisie.focus({ preventScroll: true });
      ignorerFocus = false;
    }
  }

  function afficherResultats(html) {
    el.resultats.innerHTML = html;
    const bloc = el.resultats.querySelector('[data-ent-nb]');
    afficherEssentiels(!bloc || Number(bloc.dataset.entNb) === 0);
  }

  function chercher(q) {
    if (cacheRecherche.has(q)) {
      afficherResultats(cacheRecherche.get(q));
      return;
    }
    if (controleur) controleur.abort();
    controleur = new AbortController();
    const base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    const url = `${base}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last&section_id=entete-vignettes`;
    fetch(url, { signal: controleur.signal })
      .then((r) => {
        if (!r.ok) throw new Error(String(r.status));
        return r.text();
      })
      .then((texte) => {
        const bloc = new DOMParser().parseFromString(texte, 'text/html').querySelector('.ent-res');
        if (!bloc) throw new Error('réponse sans résultats');
        cacheRecherche.set(q, bloc.outerHTML);
        if (el.saisie.value.trim() === q) afficherResultats(bloc.outerHTML);
      })
      .catch((e) => {
        if (e.name === 'AbortError') return;
        el.resultats.innerHTML = '';
        afficherEssentiels(true);
      });
  }

  function poserPlaceholder() {
    if (!el.saisie) return;
    el.saisie.placeholder = ordi.matches ? el.saisie.dataset.exemple : el.saisie.dataset.court;
  }

  function initRecherche() {
    el.saisie.dataset.exemple = el.saisie.getAttribute('placeholder');
    poserPlaceholder();
    el.saisie.addEventListener('focus', () => {
      if (!ignorerFocus) ouvrirRecherche();
    });
    el.saisie.addEventListener('click', ouvrirRecherche);
    el.saisie.addEventListener('input', () => {
      const q = el.saisie.value.trim();
      clearTimeout(minuteurRecherche);
      ouvrirRecherche();
      if (q.length < 2) {
        if (controleur) controleur.abort();
        el.resultats.innerHTML = '';
        afficherEssentiels(true);
        return;
      }
      minuteurRecherche = setTimeout(() => chercher(q), 200);
    });
    el.annuler.addEventListener('click', () => {
      el.saisie.value = '';
      el.resultats.innerHTML = '';
      afficherEssentiels(true);
      fermerRecherche(false);
      el.saisie.blur();
    });
    el.voile.addEventListener('click', () => {
      fermerRecherche(false);
      fermerApercu();
    });
    el.ent.addEventListener('focusout', () => {
      setTimeout(() => {
        if (etat.recherche && !el.ent.contains(document.activeElement)) fermerRecherche(false);
      }, 0);
    });
  }

  /* 5. Aperçu des univers : souris seulement, à partir de 1024 px ; chargé au premier survol, gardé en mémoire. C'est un
     raccourci : aria-hidden, liens hors du parcours du clavier ; au clavier et au toucher, le lien mène à l'univers. */
  const cacheApercu = new Map();
  let minuteurOuvre = null;
  let minuteurFerme = null;
  let apercuCourant = null;

  function fermerApercu() {
    clearTimeout(minuteurOuvre);
    apercuCourant = null;
    if (!etat.apercu) return;
    etat.apercu = false;
    el.apercu.hidden = true;
    majVoile();
  }

  function montrerApercu(lien) {
    const url = lien.dataset.entApercu;
    apercuCourant = url;
    const poser = (html) => {
      if (apercuCourant !== url || etat.recherche) return;
      el.apercuContenu.innerHTML = html;
      el.apercu.hidden = false;
      etat.apercu = true;
      majVoile();
    };
    if (cacheApercu.has(url)) {
      poser(cacheApercu.get(url));
      return;
    }
    fetch(`${url}${url.includes('?') ? '&' : '?'}section_id=entete-vignettes`)
      .then((r) => (r.ok ? r.text() : Promise.reject(new Error(String(r.status)))))
      .then((texte) => {
        const bloc = new DOMParser().parseFromString(texte, 'text/html').querySelector('.ent-ap');
        if (!bloc) return;
        cacheApercu.set(url, bloc.outerHTML);
        poser(bloc.outerHTML);
      })
      .catch(() => {});
  }

  function initApercu() {
    const actif = () => souris.matches && ordi.matches && !etat.recherche;
    const fermerPlusTard = () => {
      clearTimeout(minuteurOuvre);
      clearTimeout(minuteurFerme);
      minuteurFerme = setTimeout(fermerApercu, 180);
    };
    el.ent.querySelectorAll('[data-ent-apercu]').forEach((lien) => {
      lien.addEventListener('mouseenter', () => {
        if (!actif()) return;
        fermerPlus(false);
        clearTimeout(minuteurFerme);
        clearTimeout(minuteurOuvre);
        minuteurOuvre = setTimeout(() => montrerApercu(lien), etat.apercu ? 0 : 120);
      });
    });
    el.univers.addEventListener('mouseleave', fermerPlusTard);
    el.apercu.addEventListener('mouseleave', fermerPlusTard);
    el.apercu.addEventListener('mouseenter', () => clearTimeout(minuteurFerme));
  }

  /* 5 bis. Onglet « Aide & conseils » (amendement A14) : survol à la souris sur ordinateur, ou clic et clavier. Un clic sur
     l'onglet ouvert par le survol le garde ouvert (sinon le survol l'ouvrait et le clic le refermait aussitôt). */
  let minuteurPlus = null;
  let plusParSurvol = false;

  function ouvrirPlus(survol) {
    clearTimeout(minuteurPlus);
    if (etat.plus || !el.plus) return;
    fermerApercu();
    fermerRecherche(false);
    etat.plus = true;
    plusParSurvol = survol;
    el.plusPanneau.hidden = false;
    el.plusOnglet.setAttribute('aria-expanded', 'true');
  }

  function fermerPlus(rendreFocus) {
    clearTimeout(minuteurPlus);
    if (!etat.plus) return;
    etat.plus = false;
    el.plusPanneau.hidden = true;
    el.plusOnglet.setAttribute('aria-expanded', 'false');
    if (rendreFocus) el.plusOnglet.focus({ preventScroll: true });
  }

  function initPlus() {
    if (!el.plus) return;
    el.plusOnglet.addEventListener('click', () => {
      if (!etat.plus) ouvrirPlus(false);
      else if (plusParSurvol) plusParSurvol = false;
      else fermerPlus(false);
    });
    el.plus.addEventListener('mouseenter', () => {
      if (!souris.matches || !ordi.matches || etat.recherche) return;
      clearTimeout(minuteurPlus);
      minuteurPlus = setTimeout(() => ouvrirPlus(true), 120);
    });
    el.plus.addEventListener('mouseleave', () => {
      clearTimeout(minuteurPlus);
      if (etat.plus && plusParSurvol) minuteurPlus = setTimeout(() => fermerPlus(false), 180);
    });
    el.plus.addEventListener('focusout', (e) => {
      if (etat.plus && !el.plus.contains(e.relatedTarget)) fermerPlus(false);
    });
  }

  /* 6. Tiroir : dialog natif (focus piégé, Échap, retour du focus par le navigateur). */
  function initTiroir() {
    if (!el.tiroir) return;
    const boutons = document.querySelectorAll('[data-ent-tiroir-ouvrir]');
    boutons.forEach((b) => b.addEventListener('click', () => {
      fermerRecherche(false);
      fermerApercu();
      el.tiroir.showModal();
      boutons.forEach((x) => x.setAttribute('aria-expanded', 'true'));
    }));
    el.tiroir.addEventListener('close', () => boutons.forEach((x) => x.setAttribute('aria-expanded', 'false')));
    el.tiroir.addEventListener('click', (e) => {
      if (e.target === el.tiroir || e.target.closest('[data-ent-tiroir-fermer]')) el.tiroir.close();
    });
    const rechercheTiroir = el.tiroir.querySelector('[data-ent-tiroir-recherche]');
    if (rechercheTiroir) {
      rechercheTiroir.addEventListener('click', () => {
        el.tiroir.addEventListener('close', () => setTimeout(() => el.saisie.focus(), 0), { once: true });
        el.tiroir.close();
      });
    }
  }

  function init() {
    const ent = document.querySelector('[data-ent]');
    if (!ent || ent.dataset.entPret) return;
    ent.dataset.entPret = '1';
    el = {
      ent,
      section: ent.closest('.shopify-section'),
      form: ent.querySelector('[data-ent-cherche]'),
      saisie: ent.querySelector('[data-ent-saisie]'),
      annuler: ent.querySelector('[data-ent-annuler]'),
      panneau: ent.querySelector('[data-ent-panneau]'),
      resultats: ent.querySelector('[data-ent-resultats]'),
      essentiels: ent.querySelector('[data-ent-essentiels]'),
      voile: ent.querySelector('[data-ent-voile]'),
      univers: ent.querySelector('.ent-univers'),
      apercu: ent.querySelector('[data-ent-apercu-panneau]'),
      apercuContenu: ent.querySelector('[data-ent-apercu-contenu]'),
      tiroir: document.querySelector('[data-ent-tiroir]'),
      plus: ent.querySelector('[data-ent-plus]'),
      plusOnglet: ent.querySelector('[data-ent-plus-onglet]'),
      plusPanneau: ent.querySelector('[data-ent-plus-panneau]'),
    };
    etat.recherche = false;
    etat.apercu = false;
    etat.plus = false;
    initRecherche();
    initApercu();
    initPlus();
    initTiroir();
    /* Une prise de focus dans l'en-tête le fait revenir ; sur téléphone, la recherche de la ligne compacte la garde. */
    ent.addEventListener('focusin', (e) => {
      if (ordi.matches || !e.target.closest('.ent-cherche')) el.section.classList.remove('is-cache');
    });
    mesurer();
    y0 = scrollY;
    surDefilement();
  }

  function demarrer() {
    initAnnonce();
    init();
    brancherCompteur();
  }

  addEventListener('scroll', () => {
    if (!enAttente) {
      enAttente = true;
      requestAnimationFrame(surDefilement);
    }
  }, { passive: true });
  addEventListener('resize', () => {
    mesurer();
    poserPlaceholder();
  }, { passive: true });
  ordi.addEventListener('change', (e) => {
    fermerApercu();
    fermerPlus(false);
    if (e.matches && el.tiroir && el.tiroir.open) el.tiroir.close();
  });
  /* Onglet « Aide & conseils » : un clic ailleurs le ferme. */
  document.addEventListener('click', (e) => {
    if (etat.plus && !el.plus.contains(e.target)) fermerPlus(false);
  });
  addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    if (etat.apercu) fermerApercu();
    if (etat.plus) fermerPlus(el.plus.contains(document.activeElement));
    if (etat.recherche) {
      /* Dans un champ de type search, Échap efface le texte et déclenche « input », qui rouvrirait le panneau. */
      e.preventDefault();
      fermerRecherche(true);
    }
  });
  /* Éditeur de thème : la section rechargée remplace le balisage. */
  document.addEventListener('shopify:section:load', () => {
    initAnnonce();
    init();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
